<script>
  import {onMount, onDestroy, tick} from 'svelte';
  import {flip} from 'svelte/animate';
  import {Menus} from "../stores.js";

  let home_menu;
  let home_menu_proc;
  let menus = $Menus;
  let uid = menus.length + 1;
  let initialize = false;
  const homeMenuSlider = {
    direction: 'next',
    proc: null,
    init: () => {
      // stopHomeMenuSlider();
      homeMenuSlider.stop();
      if (!initialize) {
        initialize = true;
        menus.forEach(menu => menu.id = uid++);
      }
      // playHomeMenuSlider('init');
      homeMenuSlider.play('init');
      return true;
    },
    stop: () =>  clearInterval(homeMenuSlider.proc),
    play: type => {
      clearInterval(homeMenuSlider.proc);

      let next = async (cnt = 1) => {
        if (homeMenuSlider.direction === 'next') {
          for (let i = 0; i < cnt; i++) {
            let menu = menus.shift();
            menus = [...menus];
            await tick();
            menu.id = uid++;
            menus = [...menus, menu];
          }
        } else {
          for (let i = 0; i < cnt; i++) {
            let menu = menus.pop();
            menus = [...menus];

            menu.id = uid++;
            menus = [menu, ...menus];
          }
        }
      }

      if (type === 'init' || type === 'now') next();

      homeMenuSlider.proc = setInterval(next, 2000);
    },
    click: e => {
      let width = e.currentTarget.parentElement.clientWidth;
      let left = e.x;
      let right = width - e.x;
      let per = Math.min(left, right) / width * 100;
      let target = 30;

      if (target > per) {
        homeMenuSlider.direction = (left > right) ? 'next' : 'prev';
        homeMenuSlider.play('now');
      }
    }
  };

  onMount(() => homeMenuSlider.init());
  onDestroy(() => homeMenuSlider.stop());
</script>

<div class="home__menu home-menu" bind:this={home_menu}>
  <div class="header">
    <h1 class="header__heading heading heading_level_1">MENU</h1>
  </div>

  <ul class="home-menu__list" on:click={homeMenuSlider.click} on:mouseenter={homeMenuSlider.stop} on:mouseleave={homeMenuSlider.play}>
    {#each menus as menu (menu.id)}
      <li class="home-menu__item" animate:flip="{{duration: 600}}">
        <img class="home-menu__img" src="{menu.img}" alt="{menu.en_name}"/>
        <span class="home-menu__text text text_large">{menu.en_name}</span>
      </li>
    {/each}
  </ul>
</div>

<style>
  :root {
    --item-cnt: 3;
    --item-gap: 100px;
    --item-menu-text: 64px;
    --item-width: 360px;
    --item-height: calc(var(--item-width) * 1.33 + var(--item-menu-text));
    --item-padding: calc((100vw - ((var(--item-width) + var(--item-gap)) * var(--item-cnt) - var(--item-gap))) / 2);
    --item-margin-left: calc((var(--item-width) + var(--item-gap)) * -2);
  }

  .home-menu {
    position: relative;
    overflow: hidden;
    width: 100vw;
  }

  .home-menu__list {
    position: relative;
    box-sizing: border-box;
    width: fit-content;
    padding: 100px var(--item-padding) 0px;
    display: flex;
    flex-flow: row nowrap;
    gap: var(--item-gap);
    margin-left: var(--item-margin-left);
    user-select: none;
  }
  .home-menu__list:after {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    content: '';
    z-index: 10;
    background: transparent;
  }

  .home-menu__item {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    width: var(--item-width);
    height: var(--item-height);
    scroll-snap-align: center;
    scroll-snap-stop: always;
    background: var(--primary);
    border-radius: calc(var(--item-width) / 2) calc(var(--item-width) / 2) 8px 8px;
    opacity: 0.7;
    transform-origin: 50% 100%;
    transform: scale(0.85);
  }

  .home-menu__item:nth-child(3),
  .home-menu__item:nth-child(4),
  .home-menu__item:nth-child(5) {
    opacity: 1;
    transform: scale(1);
  }

  .home-menu__img {
    position: absolute;
    display: block;
    width: calc(var(--item-width) * 1.1);
    height: calc(var(--item-width) * 1.1 * 1.33);
    left: 50%;
    bottom: 64px;
    object-fit: contain;
    transition: linear 0.3S;
    transform-origin: 50% 80%;
    transform: translate(-50%, 5%) scale(1);
  }

  .home-menu__item:hover > .home-menu__img {
    transform: translate(-50%, 5%) scale(1.1);
  }

  .home-menu__text {
    position: absolute;
    bottom: 0px;
    height: var(--item-menu-text);
    padding: 0 4px 8px 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    left: 24px;
    right: 24px;
    color: var(--secondary);
  }

  .home-menu__text:before {
    position: absolute;
    display: block;
    content: '';
    top: 0px;
    left: 0px;
    right: 0px;
    font-size: 0px;
    height: 1px;
    background: var(--secondary);
  }

  @media screen and (max-width: 1700px) {
    :root {
      --item-width: 360px;
      --item-gap: 64px;
    }
  }

  @media screen and (max-width: 1440px) {
    :root {
      --item-width: 320px;
      --item-gap: 48px;
    }
  }

  @media screen and (max-width: 1280px) {
    :root {
      --item-cnt: 2;
      --item-width: 320px;
      --item-gap: 48px;
    }

    .home-menu__item:nth-child(5) {
      opacity: 0.7;
      transform: scale(0.85);
    }
  }

  @media screen and (max-width: 900px) {
    :root {
      --item-width: 240px;
      --item-gap: 24px;
    }
  }

  @media screen and (max-width: 600px) {
    :root {
      --item-cnt: 1;
      --item-width: 240px;
      --item-gap: 16px;
    }

    .home-menu__item:nth-child(4) {
      opacity: 0.7;
      transform: scale(0.85);
    }
  }

  @media screen and (max-width: 900px) {
    .home-menu__list {
      padding: 50px var(--item-padding) 0px;
      gap: var(--item-gap);
    }

    .home-menu__item {
      width: var(--item-width);
      height: var(--item-height);
      border-radius: calc(var(--item-width) / 2) calc(var(--item-width) / 2) 4px 4px;
    }

    .home-menu__text {
      height: 40px;
      padding: 0 4px 8px 4px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      left: 16px;
      right: 16px;
      font-size: 85%;
      color: var(--secondary);
    }
  }
</style>
